import { RequestFactory } from "@/requests/RequestFactory";
const storageRequest = RequestFactory.get("storage");

export default {
  namespaced: true,
  state: {
    items: {},
  },

  actions: {
    fetchConfig: ({ commit }, payload) => {
      commit;
      return storageRequest.request(payload)
    },
    mkdir: ({ commit }, payload) => {
      commit;
      return storageRequest.mkdir(payload)
    },
    rename: ({ commit }, payload) => {
      commit;
      return storageRequest.rename(payload)
    },
    list: ({ commit }, payload) => {
      commit
      return storageRequest.list(payload)
    },
  },

  getters: {
  },

  mutations: {
  }

}
